import { deleteRace } from "../../services/raceService";
import "./raceTable.css";

function RaceTable({ races, refresh, setSelectedRace }) {

  const handleDelete = async (id) => {
    await deleteRace(id);
    refresh();
  };

  return (
    <div className="table-wrapper">
      <table className="race-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Session</th>
            <th>Round</th>
            <th>Status</th>
            <th className="right">Action</th>
          </tr>
        </thead>

        <tbody>
          {races.map((race) => (
            <tr key={race.id}>
              <td className="name-cell">{race.name}</td>
              <td>{race.session}</td>
              <td>Round {race.round}</td>

              <td>
                <span className="status active">Active</span>
              </td>

              <td className="right">
                <button
                  className="edit-btn"
                  onClick={() => setSelectedRace(race)}
                >
                  Edit
                </button>

                <button
                  className="delete-btn"
                  onClick={() => handleDelete(race.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default RaceTable;